module.exports = __webpack_public_path__ + "static/media/NotoSans-Regular.2a1861cd.ttf";